import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-214231ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper pt-8 md:pt-36 text-sm font-light" }
const _hoisted_2 = { class: "four-reasons pb-5 md:pb-0 opacity-[0.7]" }
const _hoisted_3 = { class: "row-1 flex flex-col md:flex-row md:mb-20 md:px-16" }
const _hoisted_4 = { class: "liquidity md:w-80 leading-6 text-center md:text-left" }
const _hoisted_5 = { class: "md:font-bold" }
const _hoisted_6 = { class: "hidden sm:block md:text-base" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle flex-1" }, null, -1))
const _hoisted_8 = { class: "assets text-center md:text-right md:w-80 leading-6" }
const _hoisted_9 = { class: "md:font-bold" }
const _hoisted_10 = { class: "hidden sm:block md:text-base" }
const _hoisted_11 = { class: "row-2 flex flex-col md:flex-row pb-6 md:pb-0 md:mb-16 relative" }
const _hoisted_12 = { class: "w-full md:w-80 leading-6 text-center md:text-left absolute md:relative bottom-0" }
const _hoisted_13 = { class: "md:font-bold" }
const _hoisted_14 = { class: "hidden sm:block md:text-base" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center flex-1 font-bold text-md md:text-lg pb-3 md:pb-0 md:-mt-16 mx-6 md:mx-16" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-ammocorps font-normal text-3xl md:text-7xl -mb-1" }, "4"),
  /*#__PURE__*/_createElementVNode("div", { class: "reasons-wrapper" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "reasons" }, "REASONS")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "leading-6" }, "YOU'LL LOVE IT")
], -1))
const _hoisted_16 = { class: "text-center md:text-right md:w-80 leading-6" }
const _hoisted_17 = { class: "md:font-bold" }
const _hoisted_18 = { class: "hidden sm:block md:text-base" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "armory text-center relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/footer/helicopter.svg",
    class: "hidden md:block absolute left-56 h-10 top-5"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/footer/plane.svg",
    class: "hidden md:block absolute right-24 h-10 bottom-24"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/footer/armory.svg",
    class: "inline-block relative -bottom-2 w-11/12 md:w-8/12 opacity-70"
  })
], -1))
const _hoisted_20 = { class: "bg-gradient" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "road border-t border-gray-300 h-12 relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/footer/truck.png",
    class: "absolute left-24 h-6 md:h-10 -top-2 md:-top-5"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-dashed border-gray-300 top-6 relative" })
], -1))
const _hoisted_22 = { class: "mission border-t border-gray-300" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "OUR MISSION", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline md:block" }, "Our mission is to democratize the global supply chain, giving everyone an equal opportunity"),
  /*#__PURE__*/_createElementVNode("div", { class: "inline md:block" }, "to benefit from the ebbs and flows of alternative markets. " + ".")
], -1))
const _hoisted_25 = { class: "legal border-t border-gray-300" }
const _hoisted_26 = { class: "flex-1" }
const _hoisted_27 = { class: "flex flex-col-reverse md:flex-row gap-x-6" }
const _hoisted_28 = { class: "pb-3" }
const _hoisted_29 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ContentWrapper, { class: "text-gray-600 flex flex-col-reverse md:flex-none md:flex-col" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.footerSnacks[0].title), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.footerSnacks[0].text) + ". ", 1)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.footerSnacks[1].title), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.footerSnacks[1].text) + ". ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.footerSnacks[2].title), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.footerSnacks[2].text) + ". ", 1)
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.footerSnacks[3].title), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.footerSnacks[3].text) + ". " + ".", 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("section", _hoisted_22, [
        _createVNode(_component_ContentWrapper, { class: "text-gray-500 py-10 text-center text-base font-light" }, {
          default: _withCtx(() => [
            _hoisted_23,
            _hoisted_24
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_25, [
        _createVNode(_component_ContentWrapper, { class: "flex flex-col-reverse md:flex-row pt-4 pb-2 text-gray-400" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, "© Copyright 2021, " + _toDisplayString(_ctx.legalOwner) + ". All rights reserved.", 1),
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, [
                _createElementVNode("a", {
                  href: `//${_ctx.marketingDomain}/legal`,
                  class: "hover:text-indigo-400"
                }, "User Agreement", 8, _hoisted_29)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}